import { MdOutlineHourglassEmpty } from 'react-icons/md';
import { RiSendPlaneLine } from 'react-icons/ri';
import { FaCheck } from 'react-icons/fa6';

const ThreadStatus = ({ status }) => {
  if (status == 0) return <MdOutlineHourglassEmpty color="red" />;
  if (status == 1) return <RiSendPlaneLine color="orange" />;
  if (status == 2) return <FaCheck color="green" />;
};

export default ThreadStatus;
